import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IPayloadGetDashboardStatisticalApplicantSuccess,
	IPayloadGetDashboardStatisticalFranchiseSuccess,
	IPayloadGetWorkerDashboardInquiryListRequest,
	IPayloadGetWorkerDashboardInquiryListSuccess,
	IPayloadGetWorkerDashboardNoticeListRequest,
	IPayloadGetWorkerDashboardNoticeListSuccess,
	IPayloadGetWorkerDashboardNoticeReceiveListRequest,
	IPayloadGetWorkerDashboardNoticeReceiveListSuccess,
	IPayloadGetWorkerDashboardStatisticRequest,
	IPayloadGetWorkerDashboardStatisticSuccess,
	IPayloadGetWorkerDashboardUseTipListRequest,
	IPayloadGetWorkerDashboardUseTipListSuccess,
	IWorkerDashboardInquiryDetailStore,
	IWorkerDashboardNoticeDetailStore,
	IWorkerDashboardNoticeReceiveDetailStore,
	IWorkerDashboardStatisticStore,
	IWorkerDashboardUseTipDetailStore,
} from './worker-dashboard.type';

const initialState = {
	workerDashboardStatistic: {
		fetching: false,
		data: {} as IWorkerDashboardStatisticStore,
	},
	workerDashboardNotice: {
		fetching: false,
		data: [] as IWorkerDashboardNoticeDetailStore[],
	},
	workerDashboardInquiry: {
		fetching: false,
		data: [] as IWorkerDashboardInquiryDetailStore[],
	},
	workerDashboardStatisticFranchise: {
		fetching: false,
		data: {} as IPayloadGetDashboardStatisticalFranchiseSuccess,
	},
	workerDashboardStatisticApplicant: {
		fetching: false,
		data: {} as IPayloadGetDashboardStatisticalApplicantSuccess,
	},
	workerDashboardUseTip: {
		fetching: false,
		data: [] as IWorkerDashboardUseTipDetailStore[],
	},
	workerDashboardNoticeReceive: {
		fetching: false,
		data: [] as IWorkerDashboardNoticeReceiveDetailStore[],
	},
};

const workerDashboardSlice = createSlice({
	initialState,
	name: 'workerDashboard',
	reducers: {
		/**---- GET WORKER DASHBOARD LIST START ---- */
		getWorkerDashboardStatisticRequest: (
			state,
			action: PayloadAction<IPayloadGetWorkerDashboardStatisticRequest>
		) => {
			state.workerDashboardStatistic.fetching = true;
		},
		getWorkerDashboardStatisticSuccess: (
			state,
			action: PayloadAction<IPayloadGetWorkerDashboardStatisticSuccess>
		) => {
			const { workerDashboardStatistic } = action.payload;
			state.workerDashboardStatistic.data = workerDashboardStatistic;
			state.workerDashboardStatistic.fetching = false;
		},
		getWorkerDashboardStatisticFailure: (state) => {
			state.workerDashboardStatistic.fetching = false;
		},
		/**---- GET WORKER DASHBOARD LIST END ---- */

		/**---- GET WORKER DASHBOARD APPLICANT LIST START ---- */
		getWorkerDashboardStatisticApplicantRequest: (
			state,
			action: PayloadAction<IPayloadGetWorkerDashboardStatisticRequest>
		) => {
			state.workerDashboardStatisticApplicant.fetching = true;
		},
		getWorkerDashboardStatisticApplicantSuccess: (
			state,
			action: PayloadAction<IPayloadGetDashboardStatisticalApplicantSuccess>
		) => {
			state.workerDashboardStatisticApplicant.data = action.payload;
			state.workerDashboardStatisticApplicant.fetching = false;
		},
		getWorkerDashboardStatisticApplicantFailure: (state) => {
			state.workerDashboardStatisticApplicant.fetching = false;
		},
		/**---- GET WORKER DASHBOARD APPLICANT LIST END ---- */

		/**---- GET WORKER DASHBOARD FRANCHISE LIST START ---- */
		getWorkerDashboardStatisticFranchiseRequest: (
			state,
			action: PayloadAction<IPayloadGetWorkerDashboardStatisticRequest>
		) => {
			state.workerDashboardStatisticFranchise.fetching = true;
		},
		getWorkerDashboardStatisticFranchiseSuccess: (
			state,
			action: PayloadAction<IPayloadGetDashboardStatisticalFranchiseSuccess>
		) => {
			state.workerDashboardStatisticFranchise.data = action.payload;
			state.workerDashboardStatisticFranchise.fetching = false;
		},
		getWorkerDashboardStatisticFranchiseFailure: (state) => {
			state.workerDashboardStatisticFranchise.fetching = false;
		},
		/**---- GET WORKER DASHBOARD FRANCHISE LIST END ---- */

		/**---- GET WORKER NOTICE LIST START ---- */
		getWorkerDashboardNoticeListRequest: (
			state,
			action: PayloadAction<IPayloadGetWorkerDashboardNoticeListRequest>
		) => {
			state.workerDashboardNotice.fetching = true;
		},
		getWorkerDashboardNoticeListSuccess: (
			state,
			action: PayloadAction<IPayloadGetWorkerDashboardNoticeListSuccess>
		) => {
			const { content } = action.payload;
			state.workerDashboardNotice.data = content;
			state.workerDashboardNotice.fetching = false;
		},
		getWorkerDashboardNoticeListFailure: (state) => {
			state.workerDashboardNotice.fetching = false;
		},
		/**---- GET WORKER NOTICE LIST END ---- */

		/**---- GET WORKER INQUIRY LIST START ---- */
		getWorkerDashboardInquiryListRequest: (
			state,
			action: PayloadAction<IPayloadGetWorkerDashboardInquiryListRequest>
		) => {
			state.workerDashboardInquiry.fetching = true;
		},
		getWorkerDashboardInquiryListSuccess: (
			state,
			action: PayloadAction<IPayloadGetWorkerDashboardInquiryListSuccess>
		) => {
			const { content } = action.payload;
			state.workerDashboardInquiry.data = content;
			state.workerDashboardInquiry.fetching = false;
		},
		getWorkerDashboardInquiryListFailure: (state) => {
			state.workerDashboardInquiry.fetching = false;
		},
		/**---- GET WORKER INQUIRY LIST END ---- */

		/**---- GET WORKER USE TIP LIST START ---- */
		getWorkerDashboardUseTipListRequest: (
			state,
			action: PayloadAction<IPayloadGetWorkerDashboardUseTipListRequest>
		) => {
			state.workerDashboardUseTip.fetching = true;
		},
		getWorkerDashboardUseTipListSuccess: (
			state,
			action: PayloadAction<IPayloadGetWorkerDashboardUseTipListSuccess>
		) => {
			const { content } = action.payload;
			state.workerDashboardUseTip.data = content;
			state.workerDashboardUseTip.fetching = false;
		},
		getWorkerDashboardUseTipListFailure: (state) => {
			state.workerDashboardUseTip.fetching = false;
		},
		/**---- GET WORKER USE TIP LIST END ---- */

		/**---- GET WORKER NOTICE RECEIVE LIST START ---- */
		getWorkerDashboardNoticeReceiveListRequest: (
			state,
			action: PayloadAction<IPayloadGetWorkerDashboardNoticeReceiveListRequest>
		) => {
			state.workerDashboardNoticeReceive.fetching = true;
		},
		getWorkerDashboardNoticeReceiveListSuccess: (
			state,
			action: PayloadAction<IPayloadGetWorkerDashboardNoticeReceiveListSuccess>
		) => {
			const { content } = action.payload;
			state.workerDashboardNoticeReceive.data = content;
			state.workerDashboardNoticeReceive.fetching = false;
		},
		getWorkerDashboardNoticeReceiveListFailure: (state) => {
			state.workerDashboardNoticeReceive.fetching = false;
		},
		/**---- GET WORKER NOTICE RECEIVE LIST END ---- */
	},
});

export const WorkerDashboardSelectors = {
	selectStatisticFetching: (state: RootState) =>
		state.workerDashboard.workerDashboardStatistic.fetching,
	selectWorkerDashboardStatistic: (state: RootState) =>
		state.workerDashboard.workerDashboardStatistic.data,
	selectWorkerDashboardStatisticApplicant: (state: RootState) =>
		state.workerDashboard.workerDashboardStatisticApplicant.data,
	selectWorkerDashboardStatisticFranchise: (state: RootState) =>
		state.workerDashboard.workerDashboardStatisticFranchise.data,

	selectNoticeFetching: (state: RootState) =>
		state.workerDashboard.workerDashboardNotice.fetching,
	selectWorkerDashboardNotice: (state: RootState) =>
		state.workerDashboard.workerDashboardNotice.data,

	selectInquiryFetching: (state: RootState) =>
		state.workerDashboard.workerDashboardInquiry.fetching,
	selectWorkerDashboardInquiry: (state: RootState) =>
		state.workerDashboard.workerDashboardInquiry.data,

	selectUseTipFetching: (state: RootState) =>
		state.workerDashboard.workerDashboardUseTip.fetching,
	selectWorkerDashboardUseTip: (state: RootState) =>
		state.workerDashboard.workerDashboardUseTip.data,

	selectNoticeReceiveFetching: (state: RootState) =>
		state.workerDashboard.workerDashboardNoticeReceive.fetching,
	selectWorkerDashboardNoticeReceive: (state: RootState) =>
		state.workerDashboard.workerDashboardNoticeReceive.data,
};

export const WorkerDashboardActions = workerDashboardSlice.actions;
export const WorkerDashboardReducer = workerDashboardSlice.reducer;
